// vuex
import store from '../../../../Vue/Modules/Obituary/Custom/Site/store';

// views
import ModuleIndex from '../../../../Vue/Modules/Obituary/Custom/Site/SiteObituaryIndex';

const el = document.querySelector('div#obituary-module');

function getData(attr) {
    return JSON.parse(el.dataset[attr]);
}

let props = {
    hcaptchaSiteKey: el.dataset['hcaptchaSiteKey'],
    ao: el.dataset['ao']
}

if (el.dataset['obituaries']) props['obituaries'] = getData('obituaries');
if (el.dataset['obituary']) props['obituary'] = getData('obituary');

if (el) {
    window.site_obituary_list_vue_instance = new Vue({
        store,
        el: el,
        render: h => h(ModuleIndex, {
            props: props
        })
    });
}